import { useQuery } from "@tanstack/react-query";
import { graphierQLNextClient } from "utils";
import {
	SpatialQueryGidsQuery,
	SpatialQueryGidsQueryVariables,
} from "~map-view/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	query SpatialQueryGids($input: SpatialQueryInput!) {
		spatialQueryGids(input: $input) {
			gids
			bbox
			processTime
		}
	}
`;

export const useSpatialQueryGids = (
	variables: SpatialQueryGidsQueryVariables,
) => {
	return useQuery({
		enabled: false,
		queryKey: ["spatialQueryGids", variables],
		queryFn: () =>
			graphierQLNextClient<
				SpatialQueryGidsQuery,
				SpatialQueryGidsQueryVariables
			>({
				query,
				variables,
				useKey: true,
			}).then((res) => res.spatialQueryGids),
	});
};
